import React from 'react';

interface Message {
    message: string,
    severity: "error" | "info" | "success" | "warning",
}

interface MessageContext {
    message?: Message;
    setMessage: Function;
}

const GlobalMessageContext = React.createContext<MessageContext | undefined>(undefined);

export default GlobalMessageContext;